import { connect } from 'react-redux'
import freeDomains from 'free-email-domains'
import isEmail from 'validator/lib/isEmail'
import { isEmpty, password } from 'util/validation'
import { selectAccountIsOnboardingCompleted } from 'selectors/app'
import withFormFields from 'shared/ui/Form/withFormFields'

import { doSaveAndRedirect } from './actions'
import { doRedirectIfAuthenticated } from '../actions'
import EmailPageView from './view'

// NOTE (jscheel): This is significantly faster than filter for this use-case
const freeDomainsSansGmail = [...freeDomains]
const gmailIndex = freeDomainsSansGmail.indexOf('gmail.com')
if (gmailIndex > -1) freeDomainsSansGmail.splice(gmailIndex, 1)

const isValidEmail = value => {
  if (isEmpty(value)) {
    return 'An email address is required'
  }
  if (
    !isEmail(value, {
      host_blacklist: freeDomainsSansGmail,
    })
  ) {
    return 'Please enter your work email address'
  }

  return null
}

const validators = {
  emailInput: isValidEmail,
  password,
}

const initialValues = {
  emailInput: '',
  password: '',
}

const select = state => ({
  initialValues,
  validators,
  isOnboardingComplete: selectAccountIsOnboardingCompleted(state),
})

const perform = {
  onSave: doSaveAndRedirect,
  redirectIfAuthenticated: doRedirectIfAuthenticated,
}

export default connect(select, perform)(withFormFields(EmailPageView))
